<template>
  <div class="fillcontain">
    <div class="table_container">
      <el-row>
        <el-button type="primary" @click="handleEdit(0, '','add')">新增分组</el-button>
      </el-row>
      <br/>
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading">
        <el-table-column label="主图">
          <template slot-scope="scope">
            <img :src="scope.row.pic.showThumbnail" v-if="scope.row.pic != null" width="50" height="50"/>
          </template>
        </el-table-column>
        <el-table-column
          label="分组名"
          prop="name">
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row,'edit')">
              编辑
            </el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handleDeleteAlert( scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pages.page"
          :page-size="pages.pageSize"
          layout="total, prev, pager, next"
          :total="pages.total">
        </el-pagination>
      </div>

      <el-dialog :title="dialog.title" :visible.sync="dialog.dialogFormVisible" :close-on-click-modal="dialog.close">
        <el-form :model="goods_group">
          <el-form-item label="分组名" label-width="100px">
            <el-input v-model="goods_group.name" auto-complete="off"  maxlength="100" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="图片" label-width="80px">
            <div style="text-align: left;margin: 5px">
              <el-upload
                :limit="picLimit"
                :action="uploadUrl"
                list-type="picture-card"
                :on-preview="handlPicPreview"
                :before-remove="handleBeforeRemove"
                :on-success="handleSuccess"
                :file-list="picFiles"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div v-show="picVisible" size="tiny">
                <img width="100%" :src="picUrl" alt="">
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialog.dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSave">确 定</el-button>
        </div>
      </el-dialog>


    </div>
  </div>
</template>

<script>
    export default {
        data(){
            return {
                picLimit:1,
                uploadUrl:window.server.baseUrl+'/common/imageUpload',
                loading:false,
                goods_group:{
                    id:0,
                    name:"",
                    pic_ids:""
                },
                dialog:{
                    dialogFormVisible:false,
                    title:"新增菜品分组",
                    close:false,
                },
                pages:{
                    offset: 0,
                    pageSize: 10,
                    page: 1,
                    total: 0,
                },
                tableData: [],
                groupChecks:[],
                picFiles:[],
                picVisible:false,
                picUrl:"",
            }
        },
        created(){
            this.initData();
        },
        methods: {
            initData(){
                this.loading = true;
                var that = this;
                that.$api.get('/store/goods_groups', that.pages, response => {
                    if (response.status >= 200 && response.status < 300) {
                        var res = response.data;
                        if (res.code == 0) {
                            that.tableData = res.data.goods_groups.content;
                            that.pages.total = res.data.goods_groups.totalElements;
                        }else{
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                        }
                    } else {
                        this.$message({
                            message: "服务器维护中",
                            type: 'error'
                        });
                    }
                    this.loading = false;
                });
            },

            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.pages.page = val;
                this.pages.offset = (val - 1)*this.pages.pageSize;
                this.initData()
            },

            handleBeforeRemove(file, fileList){
                var that = this;
                this.$confirm('此操作将删除该图片, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    that.handleRemove(file, fileList);
                }).catch(() => {

                });
                return false;
            },
            handleRemove(file, fileList) {
                console.log(file);
                var index = this.picFiles.indexOf(file);
                console.log(index);
                if (index > -1) {
                    this.picFiles.splice(index, 1);
                }
                console.log(this.picFiles)
            },
            handleSuccess(response,file, fileList) {
                file.id = response.ids[0];
                console.log(response);
                file.url = response.thumbnails[0];
                file.downloadUrl = response.data[0];
                file.md5 = response.md5s[0];
                file.ext = response.exts[0];
                this.picFiles.push(file);
            },
            handlPicPreview(file) {
                console.log(file);
                //BMP,JPG、JPEG、PNG
                if(file.ext.toLowerCase() == ".jpg" || file.ext.toLowerCase() == ".bmp" || file.ext.toLowerCase() == ".jpeg" || file.ext.toLowerCase() == ".png"){
                    if(this.picUrl == file.downloadUrl){
                        this.picVisible = !this.picVisible;
                    }else{
                        this.picVisible = true;
                    }
                    this.picUrl = file.downloadUrl;

                }else{
                    this.picVisible = false;
                    location.href = file.downloadUrl;
                }

            },

            handleEdit(index, row,action) {
                this.picFiles = new Array();
                if(action == "edit"){
                    this.dialog.title = "修改菜品分组";
                    this.goods_group.id = row.id;
                    this.goods_group.name = row.name;
                    this.dialog.dialogFormVisible = true;
                    if(row.pic != null){//图片处理
                        var imgObj = row.pic;
                        var img = {name: imgObj.name, url: imgObj.showThumbnail,id:imgObj.id,downloadUrl:imgObj.showUrl,ext:imgObj.ext,md5:imgObj.md5}
                        this.picFiles.push(img);

                    }
                }else if(action == "add"){
                    this.dialog.title = "新增菜品分组";
                    this.goods_group.id = 0;
                    this.goods_group.name = "";
                    this.dialog.dialogFormVisible = true;
                }
            },

            handleSave() {
              if(this.goods_group.name == ''){
                this.$message({
                  message: "名字不能为空",
                  type: 'warning'
                });
                return;
              }
                this.loading = true;
                var that = this;
                if(that.picFiles.length > 0){
                    that.goods_group.pic_md5 = this.picFiles[0].md5;
                }
                that.$api.post('/store/goods_groups', that.goods_group, response => {
                    if (response.status >= 200 && response.status < 300) {
                        console.log(response.data);
                        var res = response.data;
                        if (res.code == 0) {
                            this.$message({
                                message: that.dialog.title+'成功',
                                type: 'success'
                            });
                            this.dialog.dialogFormVisible = false;
                            this.initData();
                        }else{
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                        }
                    } else {
                        this.$message({
                            message: "服务器维护中",
                            type: 'error'
                        });
                    }

                });

                this.loading = false;
            },
            handleDeleteAlert(row) {
                this.$confirm('此操作将删除该菜品分组, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.handleDelete(row);
                }).catch(() => {

                });
            },
            handleDelete(row) {
                this.loading = true;
                var that = this;
                that.$api.delete('/store/goods_groups/'+row.id, null, response => {
                    if (response.status >= 200 && response.status < 300) {
                        console.log(response.data);
                        var res = response.data;
                        if (res.code == 0) {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                            this.initData();
                        }else{
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                            this.loading = false;
                        }
                    } else {
                        this.$message({
                            message: "服务器维护中",
                            type: 'error'
                        });
                        this.loading = false;
                    }

                });
            },
        },
    }
</script>

<style lang="less">
  @import '../../style/mixin';
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .table_container{
    padding: 20px;
    text-align: left;
  }
  .Pagination{
    display: flex;
    justify-content: flex-start;
    margin-top: 8px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/pages/store/GoodsGroups.vue